import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Button,
  Box
} from "@mui/material";
import { cicassService } from "../../../_services";

const apiEndpointGetAttendanceType = "ana_attendance_type";
const apiEndpointGetLastAttendance = "attendance/last";

const AttendanceDialog = props => {
  const { isOpen, handleClose, onSubmit, translate, isSubmitDisabled, isInSede } = props;

  const [attendanceCauseOptions, setAttendanceCauseOptions] = useState([]);
  const [tempAttendanceCause, setTempAttendanceCause] = useState("");
  const [tempAttendanceNote, setTempAttendanceNote] = useState("");
  const [lastAttendance, setLastAttendance] = useState({
    cause: "",
    note: "",
  });

  useEffect(() => {
    if (isOpen) { // Carica i dati solo quando il dialog si apre
      fetchData();
    }
  }, [isOpen]);

  async function fetchData() {
    const { data: attendanceCauseOptns } = await cicassService.getAll(apiEndpointGetAttendanceType);
    setAttendanceCauseOptions(attendanceCauseOptns);

    let { data: lastAttendanceResponse } = await cicassService.getAll(apiEndpointGetLastAttendance);

    if (lastAttendanceResponse.toDt === null) {
      const lastAttendanceId = lastAttendanceResponse.anaAttendanceTypeId;
      const lastAttendanceCause = attendanceCauseOptns.find(item => item.id === lastAttendanceId)?.name || "";

      setLastAttendance({
        cause: lastAttendanceCause,
        note: lastAttendanceResponse.attendanceNote,
      });

      setTempAttendanceNote(lastAttendanceResponse.attendanceNote);
      setTempAttendanceCause(lastAttendanceId);
    } else {
      setTempAttendanceCause("");
      setTempAttendanceNote("");
      setLastAttendance({ cause: "", note: "" });
    }
  }

  const handleConfirm = () => {
    if (tempAttendanceCause) {
      onSubmit(tempAttendanceCause, tempAttendanceNote);
      fetchData();
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle sx={{ color: "black", fontWeight: "bold", fontSize: "1.2rem" }}>
        {translate("stamp")}
        {" "}
        ({isInSede ? (translate("attendanceExit") || "Uscita") : (translate("attendanceEntrance") || "Ingresso")})
      </DialogTitle>
      <DialogContent sx={{ padding: "2rem" }}>
        <Box sx={{ mb: 3 , mt: 2}}>
          
          <FormControl fullWidth>
            <InputLabel>{translate("anaAttendanceTypeId")}</InputLabel>
            <Select
              value={tempAttendanceCause}
              onChange={(e) => setTempAttendanceCause(e.target.value)}
              label={translate("anaAttendanceTypeId")}
              fullWidth
            >
              {attendanceCauseOptions.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography gutterBottom>{translate("attendanceNote")}</Typography>
          <TextField
            value={tempAttendanceNote}
            onChange={(e) => setTempAttendanceNote(e.target.value)}
            multiline
            rows={3}
            fullWidth
          />
        </Box>

        <Box display="flex" justifyContent="flex-end" gap={2} sx={{ mt: 1 }}>
         
          <Button variant="outlined" onClick={handleClose} sx={{ borderRadius: "8px", textTransform: "none" }}>
            {translate("cancelBtn")}
          </Button>
          <Button
            variant="contained"
            disabled={isSubmitDisabled}
            onClick={handleConfirm}
            sx={{ 
              borderRadius: "8px", 
              bgcolor: isInSede ? "#d69e2e" : "#1a365d",
              color: isInSede ? "#1a202c" : "#fff",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: isInSede ? "#b7842a" : "#2c5282",
              }
            }}
          >
            {translate("confirm")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AttendanceDialog;
